import { FC } from 'react'

import LabelAndInfo from '../LabelAndInfo'

const OrderNumber: FC<{
  orderNumber: string | null | undefined
}> = ({ orderNumber }) => {
  const info = orderNumber || 'Not provided'
  const variant = orderNumber ? 'standard' : 'deemphasized'

  return <LabelAndInfo info={info} label="Order number" variant={variant} />
}

export default OrderNumber
